import React, { Component } from 'react';
import { isEmpty } from "lodash";
import InputText, { TextArea, InputSelectNative } from '../../../../commonModules/interface/form-input-inline';
import CommercialHelp from './CommercialHelp';
import { Box } from '@material-ui/core';
import DatePicker from '../../../../commonModules/MUI/DatePicker';

class AddAlert extends Component {
    state = {  }
    handleChange = (e) => {
        this.props.handleChange(e)
    }
    handleChangeDate = (date) => {
        console.log('=============== CHANGE DATE INFO=====================');
        console.log({date});
        console.log('====================================');
        this.props.handleChangeDate(date)
    }
    render() {
        return (
            <Box>
            {/* title='Ajouter une Alerte' */}
                <InputSelectNative 
                    onChange={this.handleChange} 
                    value={this.props.actionAlert} 
                    name="actionAlert"
                    label="Action à Réaliser"
                    required
                    options={[
                        <option>Rappeler le Client</option>,
                        <option>Vérifier Paiement</option>,
                    ]}
                    error={this.props.errors.actionAlert}
                />
                
                <DatePicker 
                    label="Le"
                    minDate={new Date()}
                    value={this.props.dateAlert}
                    onChange={this.handleChangeDate}
                />
                
                <TextArea
                    id="comment" 
                    onChange={this.handleChange} 
                    value={this.props.comment} 
                    name="comment" 
                    rows={5}
                    label="Infos"
                    error={this.props.errors.comment}
                />
            </Box>
        );
    }
}

export default AddAlert;